export default "__VITE_ASSET__CHtV8ML5__"